module.exports = __webpack_public_path__ + "static/news-header-ac89d53bae999e35dacbf6544ddc7d46.jpg";